import { BaseForm } from './form_mixin';

export class BaseHTMLForm extends BaseForm {
  public submit(){
    this.formElement().submit();
  }
}
